$(function(){

    const
        breakp      = '(min-width: 768px)', // ブレークポイント
        is          = new isMode(breakp),
        $window     = $(window),
        $home       = $('#home'),
        $body       = $('body'),
        $globalnavi = $('#globalnavi').find('.menu');

    // is クラスのプロパティ
    // is.Mobile UAがスマホか判定
    // is.Prod   モードが'product'か判定
    // is.IE     UAがIEまたはEdgeか判定
    // is.Breakp ブレークポイントより大きいか判定

    // resize scroll 書き方サンプル(駄目な書き方)
    // let timer = false,
    // resizeFnc = () => {
    //     if (!is.Breakp) {
    //         // スマホ向け
    //     } else {
    //         // PC向け
    //     }
    // }; resizeFnc();
    // $window.on('resize scroll', () => {
    //     if (timer !== false) clearTimeout(timer);
    //     timer = setTimeout( () => {
    //         resizeFnc();
    //     }, 20);
    // });
// -----------------------------------------------------------------------------------

    // telをモバイル以外で非活性化
    if (!is.Mobile) {
        $('a[href^="tel:"]').on('click', (e) => {
            e.preventDefault();
        });
    }
// -----------------------------------------------------------------------------------

    /**
     * 各種イベント発生時に実行したい関数
     */

    // ブレークポイントの変化で実行したいものをここに書く
    let BreakPointEvents = () => {
        $('.zdo_drawer_button, .overlay, #header,.zdo_drawer_close,#toPartner,.globalnavi,li').removeClass('active');
        getMdwH();
    };
// -----------------------------------------------------------------------------------

    /**
     * modal window
     */
    // addEventListener('scroll' , getMdwH);
    let getMdwH = function(){
        let bodyH = $('body').height();
        let bodyW = $('body').width();
        let headerH = $('#header').height();
        let mdwH = bodyH + headerH;
        let mdw = document.getElementById("mdw");
        let mdbody = document.getElementById("mdbody");
        let topmargin = bodyW / 100 * 9 ;
        let mdwT = pageYOffset + topmargin ;
        mdw.style.cssText = "height:"+ mdwH +"px;";
        mdbody.style.cssText = "top:" + mdwT + "px;";
    };

    $(document).on('click', '#toPartner', function() {
        getMdwH();
        $('#mdw, .mdover').toggleClass('active');
    });
    $(document).on('click', '#mdwClose, .mdover', function() {
        $('#mdw, .mdover').removeClass('active');
    });


    /**
    * スクロールイベント　ヘッダー、グローバルメニュー、スクロール追従ボタンの処理
    */
    let ticking = false, scrollstatus = 0, scrolling;
    let scrollEventItems = () => {
        if (!ticking) {
            requestAnimationFrame(function() {
                ticking = false;

                /**
                 * パートナー募集ボタン
                 */
                let toPartner = document.getElementById("toPartner");
                let footer = document.getElementById( "footer" ) ;
                let clientRect = footer.getBoundingClientRect() ;
                let footery = window.pageYOffset + clientRect.top ;

                let scrolling = window.innerHeight + window.pageYOffset;

                if ( scrolling < 1200 ) {
                    toPartner.style.cssText = "display:none;opacity:0;";
                }else if ( scrolling >= 1200 && scrolling <= 1500 ) {
                    toPartner.style.cssText = "display:flex;opacity:0;transition: .5s all ease-in;";
                }else if ( scrolling > 1500 && scrolling < 1800 ) {
                    toPartner.style.cssText = "display:flex;opacity:1;transition: .5s all ease-in;";
                }else if ( scrolling < footery ) {
                    toPartner.style.cssText = "display:flex;opacity:1;position:fixed;top:auto;bottom:6.5rem;";
                } else {
                    toPartner.style.cssText = "display:flex;opacity:1;position:absolute;top:auto;bottom:26rem;";
                }

                /**
                 * header scroll event
                 */
                let e = $('.zdo_drawer_button').hasClass('active'); // サブメニューオープン判定
                if(!e){
                    let hederheight = $('#header').height(),
                    globalMenuStickyInit = (h) => { // スティッキーの初期設定
                
                    $('#header').addClass('sticky-h');
                    $body.addClass('sticky-b');
                    },
                    globalMenuFixOnOff = (sc) => {
                        if (hederheight < sc) {
                            globalMenuStickyInit(hederheight);
                        } else {
                            $body.removeClass('sticky-b');
                            $('#header').removeClass('sticky-h sticky-ani');
                        }
                    };
                    // 処理
                    scrolling = window.pageYOffset;
                    globalMenuFixOnOff(scrolling);
                    if (scrollstatus < scrolling) { // 下にスクロールの時
                        $('#header').removeClass('sticky-ani');
                    } else { // 上にスクロールの時
                        $('#header').addClass('sticky-ani');
                    }
                }
                scrollstatus = scrolling;
            });
            ticking = true;
        }
    }

    document.addEventListener('scroll', scrollEventItems, {passive: true});

    // if (is.Mobile) {
    //     document.addEventListener('scroll', globalMenuSticky, {passive: true});
    // }
    
    /**
     * スマホ表示 グローバールメニューの開閉
     */

    if (! $('.overlay').length ) $body.append('<div class="overlay">');

    $(document).on('click', '.zdo_drawer_button, .overlay', () => {
        $('.zdo_drawer_button, .overlay,.zdo_drawer_close,#toPartner,.globalnavi').toggleClass('active');
    });
    $(document).on('click', '.globalnavi a', () => {
        $('.zdo_drawer_button, .overlay,.zdo_drawer_close,#toPartner,.globalnavi').removeClass('active');
    });

// -----------------------------------------------------------------------------------


    /**
     * ブレークポイントの変更を検知
     */
    const mediaQueryList = matchMedia(breakp);
    mediaQueryList.addListener( BreakPointEvents );


// -----------------------------------------------------------------------------------


});
